import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BankAccountsServices = {
  async getHighestBankRecordCode() {
    const getHighestBankRecordCode = {
      url: "api/BankRecord",
      top: "1",
      orderby: "Code desc",
      select: ["Code"]
    };
    return await ApiService.oDataGet(getHighestBankRecordCode);
  },
  async getBankRecordByCode(Code) {
    const getBankRecordByCode = {
      url: "api/BankRecord",
      top: "1",
      filter: [`Code eq ${Code}`]
    };
    return await ApiService.oDataGet(getBankRecordByCode);
  },
  async getTradingPartners() {
    const getTradingPartners = {
      url: "api/TradingPartnerList",
    };
    return await ApiService.oDataGet(getTradingPartners);
  },
  async getThisFiscalPeriodAndYear(reconcileFrom) {
    const getThisFiscalPeriod = {
      url: "api/AccountingPeriod",
      top: "1",
      filter: [`DateStart le ${reconcileFrom} and DateEnd ge ${reconcileFrom}`],
      select: ["ThisFiscalPeriod", "ThisPeriodFiscalYear"]
    };
    return await ApiService.oDataGet(getThisFiscalPeriod);
  },
  async saveBankRecord(_payload) {
    var url = "api/Save_BankRecord"
    return await ApiService.post(url, _payload);
  },

  async getCustomData(params) {

    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
      select: params.select,
      orderby: params.orderby
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getDetailsListData(params) {

    const requestScreenData = {
      url: "api/BankReconciliationDetail",
      filter: params.filter,
      orderby: params.orderby
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async saveRestateBookBalance(_payload) {
    var url = "api/Save_RestateBookBalance"
    return await ApiService.post(url, _payload);
  },

  async getGroupedReconciliationDetail(code) {

    const requestScreenData = {
      url: "api/BankReconciliationDetail/Grouped/" + code,
    };

    return await ApiService.oDataGet(requestScreenData);

  }


}
export { BankAccountsServices }